import nationalFormatPhoneNumber from '@utils/nationalFormatPhoneNumber';

export const formatDuration = seconds => {
  const rawMinutes = (Math.trunc((seconds / 60) * 100) / 100)
    .toString()
    .split('.');
  const min = rawMinutes[0] || 0;
  const sec = rawMinutes[1] || 0;

  return `${min} m ${sec} s`;
};

export const transformCallData = (data, tenantCountryCode) => {
  return {
    'AI Details': [
      { label: 'Gender', value: data.gender },
      { label: 'Language', value: data.language },
      { label: 'Name', value: data.assistantName },
      {
        label: 'Phone Number',
        value: nationalFormatPhoneNumber(
          data.assistantPhoneNumber,
          tenantCountryCode,
        ),
      },
      {
        label: 'Caller Number',
        value: nationalFormatPhoneNumber(data.callingNumber, tenantCountryCode),
      },
    ],
    'Ticket Details': [
      { label: 'Ticket Link', value: data.ticketLink },
      { label: 'Ticket Summary', value: data.ticket.ticketSummary },
      { label: 'Ticket Details', value: data.ticket.ticketDetails },
      { label: 'Ticket Contact', value: data.ticket.contactName },
      { label: 'Ticket Company', value: data.ticket.companyName },
    ],
    'Call Details': [
      { label: 'Audio Recording', value: data.callRecord },
      { label: 'Transcript', value: data.callTranscript },
      { label: 'Evaluation Score', value: data.evaluation },
      { label: 'Evaluation Analysis', value: data.evaluationAnalysis },
      { label: 'Sentiment Analysis', value: data.sentimentAnalysis },
      { label: 'Call ID', value: data.callId },
      { label: 'Duration', value: formatDuration(data.callDuration) },
    ],
  };
};

export default transformCallData;
